<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: 'App',
    };
</script>

<style>
    * {
        margin: 0;
        padding: 0;
    }

    html,
    body {
        width: 100%;
        height: 100%;
        font-size: 14px;
    }

    #app {
        font-size: 14px;
        width: 100%;
        max-width: 1980px;
        min-width: 1280px;
        margin: 0 auto;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue